{
  "privacy": {
    "slug": "privacy",
    "header": {
      "eyebrowIcon": "lock",
      "eyebrow": "Informativa · GDPR",
      "title": "Informativa",
      "titleAccent": "Privacy",
      "lead": "Ai sensi del Regolamento UE 2016/679 (General Data Protection Regulation), relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali."
    },
    "intro": "Il trattamento dei dati sarà improntato ai principi di correttezza, liceità, trasparenza e tutela della riservatezza e dei diritti dell’utente.",
    "meta": [
      {
        "icon": "scale",
        "text": "Regolamento UE 2016/679"
      },
      {
        "icon": "lock",
        "text": "Cookie · Provv. Garante 8 Mag 2014"
      },
      {
        "icon": "clock",
        "text": "Soggetta ad aggiornamenti"
      }
    ],
    "body": [
      {
        "type": "html",
        "html": "<p>Questa informativa per gli utenti/visitatori che interagiscono con il sito web <strong>www.spadhausen.com</strong> è resa ai sensi del Regolamento UE 2016/679 relativo “alle persone fisiche con riguardo al trattamento dei dati personali nonché alla libera circolazione di tali dati” ed alla normativa di cookie sulla rete ed in particolare dell’emanazione del Provvedimento del Garante della Privacy dell’8 Maggio 2014 “Individuazione delle modalità semplificate per l’informativa e l’acquisizione del consenso per l’uso dei cookie” e dei successivi “Chiarimenti in merito all’attuazione della normativa in materia di cookie” emessi il 5 giugno 2015.</p><p>La stessa descrive esclusivamente le modalità di gestione del sito, in riferimento al trattamento dei dati personali degli utenti/visitatori che lo consultano, e non anche di siti web esterni consultabili dagli utenti cliccando sui link presenti su tale sito. Informazioni aggiuntive potranno essere fornite all’interno di specifiche sezioni.</p>"
      },
      {
        "type": "html",
        "html": "<h2>Tipologia di dati trattati e finalità del trattamento</h2>\n<h3>1.1 — Dati di navigazione</h3>\n<p>I sistemi informatici e gli applicativi dedicati al funzionamento di questo sito web acquisiscono, nel corso del loro normale esercizio, alcuni dati personali la cui trasmissione è implicita nell’uso dei protocolli di comunicazione di Internet. Si tratta di informazioni che non sono raccolte per essere associate a interessati identificati, ma che per loro stessa natura potrebbero, attraverso elaborazioni ed associazioni con dati detenuti da terzi, permettere di identificare gli utenti/visitatori.</p>\n<p>Tra i dati raccolti sono compresi gli indirizzi IP o i nomi a dominio dei computer utilizzati dagli utenti che si connettono al sito, gli indirizzi in notazione URI (Uniform Resource Identifier) delle risorse richieste, l’orario della richiesta, il metodo utilizzato nel sottoporre la richiesta al server, la dimensione del file ottenuto in risposta, il codice numerico indicante lo stato della risposta data dal server ed altri parametri relativi al sistema operativo e all’ambiente informatico dell’utente. Questi dati vengono trattati, per il tempo necessario al raggiungimento della finalità per cui sono raccolti, al solo fine di ricavare informazioni statistiche anonime sull’uso del sito e per controllarne il regolare funzionamento. I dati potrebbero essere utilizzati per l’accertamento di responsabilità in caso di ipotetici reati informatici ai danni del sito.</p>\n<h3>1.2 — Dati forniti volontariamente dall’utente</h3>\n<p>L’invio di messaggi di posta elettronica agli indirizzi indicati su questo sito (ad esempio al fine di chiedere informazioni) comporta l’acquisizione dell’indirizzo del mittente, nonché degli eventuali altri dati personali inseriti nei messaggi. Tali dati saranno trattati unicamente al fine di evadere la richiesta e comunicati a terzi nei soli casi in cui ciò sia necessario per l’adempimento della stessa (es. servizio di spedizione della documentazione richiesta).</p>\n<p>Qualora agli utenti/visitatori sia richiesto, per accedere a determinati servizi, di conferire propri dati personali, sarà previamente rilasciata, nelle pagine relative ai singoli servizi, apposita e dettagliata Informativa sul relativo trattamento ai sensi della normativa vigente che specificherà limiti, finalità e modalità del trattamento stesso.</p>\n<h3>1.3 — Cookie</h3>\n<h4>Descrizione dei cookie</h4>\n<p>I cookie sono piccoli file di testo che vengono inviati dal sito web visitato dall’utente sul dispositivo dell’utente stesso (solitamente al browser), dove vengono memorizzati in modo che tale dispositivo possa essere riconosciuto alla successiva visita. I cookie possono essere installati non solo dallo stesso gestore del sito visitato (cookie di prima parte), ma anche da un sito diverso che li installa per il tramite del primo sito (cookie di terze parti) ed è in grado di riconoscerli.</p>\n<h4>Cookie tecnici e di profilazione</h4>\n<p>I cookie tecnici sono installati al solo fine di effettuare la trasmissione di una comunicazione su una rete di comunicazione elettronica, o nella misura strettamente necessaria al fornitore di un servizio esplicitamente richiesto dall’utente. L’utilizzo dei cookie tecnici non richiede il consenso degli utenti. I cookie di profilazione servono a tracciare la navigazione dell’utente ed analizzarne il comportamento ai fini marketing: possono essere installati solo se l’utente abbia espresso il proprio consenso con le modalità indicate nel Provvedimento.</p>\n<h4>Cookie utilizzati sul presente sito</h4>\n<p>Il presente sito fa uso di <strong>cookie tecnici</strong>, per consentire una navigazione sicura ed efficiente sul sito e monitorarne il funzionamento, e — esclusivamente previo consenso dell'utente — di <strong>cookie statistici di terza parte</strong> (Google Analytics 4), descritti al paragrafo seguente.</p>\n<h4>Google Analytics 4 (cookie statistici)</h4>\n<p>Il sito utilizza Google Analytics 4, servizio di analisi web fornito da Google Ireland Limited (\"Google\"), per raccogliere statistiche aggregate sull'utilizzo del sito (pagine visitate, provenienza della visita, tipo di dispositivo). I relativi cookie sono installati <strong>solo dopo che l'utente ha espresso il consenso</strong> tramite l'apposito banner: in assenza di scelta o in caso di rifiuto, il servizio opera in modalità a consenso negato (Google Consent Mode), senza cookie né identificatori riconducibili all'utente. I dati raccolti da Google Analytics non sono utilizzati per finalità pubblicitarie né di profilazione; la misurazione delle conversioni pubblicitarie, attiva solo con il consenso «Accetta tutto», è descritta al paragrafo seguente.</p>\n<h4>Misurazione delle conversioni pubblicitarie (Google Ads)</h4>\n<p>Solo se l'utente sceglie «Accetta tutto» nel banner, il sito utilizza Google Ads, servizio fornito da Google Ireland Limited, per misurare l'efficacia dei propri annunci. Quando l'utente arriva sul sito da un annuncio di Spadhausen su Google, l'identificativo del clic generato da Google (parametri gclid, gbraid o wbraid) viene conservato nella memoria del browser per un massimo di 90 giorni e, se l'utente invia una richiesta di contatto o un ordine, viene associato alla richiesta. Spadhausen comunica poi a Google, tramite lo stesso identificativo, che quel clic ha prodotto una richiesta o un ordine, con data e ora; nome, telefono, email e gli altri dati della richiesta non vengono trasmessi a Google. Con lo stesso consenso Google può installare propri cookie di misurazione delle conversioni.</p>\n<p>Questi dati non sono utilizzati per mostrare pubblicità personalizzata (remarketing). Base giuridica: consenso dell'utente (art. 6, par. 1, lett. a GDPR). Il consenso può essere revocato in qualsiasi momento eliminando i dati di navigazione del sito dal browser: alla visita successiva il banner verrà nuovamente proposto. Scegliendo «Solo statistiche» resta attivo soltanto quanto descritto per Google Analytics 4. Per il trattamento dei dati da parte di Google: policies.google.com/technologies/ads.</p>\n<h4>Come si cancellano i cookie</h4>\n<p>Quasi tutti i browser web sono impostati per accettare automaticamente i cookie di prima parte. È possibile modificare la configurazione predefinita attraverso le impostazioni del browser; la disabilitazione o cancellazione dei cookie potrebbe però precludere la fruizione ottimale del sito. Si rimanda alle guide dei principali browser:</p>\n<ul>\n<li><a href=\"https://support.google.com/chrome/answer/95647?hl=it\" target=\"_blank\" rel=\"noopener noreferrer\">Google Chrome</a></li>\n<li><a href=\"http://support.mozilla.org/it/kb/Eliminare%20i%20cookie\" target=\"_blank\" rel=\"noopener noreferrer\">Mozilla Firefox</a></li>\n<li><a href=\"http://support.apple.com/kb/ph11920\" target=\"_blank\" rel=\"noopener noreferrer\">Safari</a></li>\n</ul>"
      },
      {
        "type": "html",
        "html": "<h2>Modalità del trattamento</h2><p>Il trattamento dei dati personali viene effettuato attraverso strumenti automatizzati (ad es. procedure e supporti elettronici) e/o manualmente (ad es. su supporto cartaceo) per il tempo strettamente necessario a conseguire gli scopi per i quali i dati sono stati raccolti e, comunque, in conformità alle disposizioni normative vigenti in materia.</p><p>Il trattamento sarà inoltre effettuato con logiche di organizzazione ed elaborazione strettamente correlate alle finalità stesse e comunque in modo da garantire la sicurezza, l’integrità e la riservatezza dei dati nel rispetto delle misure organizzative, fisiche e logiche previste dalle disposizioni vigenti.</p>"
      },
      {
        "type": "html",
        "html": "<h2>Facoltatività del conferimento dei dati</h2>\n<p>Salvo quanto sopra specificato per i dati di navigazione ed i cookie, il visitatore è libero di fornire o meno propri dati personali, come nel caso di richieste di informazioni o di contatto inviate tramite posta elettronica o di richieste di accesso a servizi, utilities ed applicazioni liberamente scelti. Il loro mancato conferimento può comportare l’impossibilità di ottenere quanto richiesto e può precludere a <strong>Spadhausen S.R.L. Unipersonale</strong> la possibilità di assolvere agli adempimenti contrattuali come previsti dal contratto di mandato.</p>"
      },
      {
        "type": "html",
        "html": "<h2>Titolare, responsabili e categorie di incaricati</h2>\n<p>Il Titolare del trattamento dei dati personali è <strong>Spadhausen S.R.L. Unipersonale</strong>, con sede in Ravenna, Via Faentina 175/A. I trattamenti connessi ai servizi web di questo sito sono curati esclusivamente dalla società Spadhausen S.R.L. Unipersonale e dal personale tecnico incaricato del trattamento.</p>\n<p>Oltre che dai dipendenti del Titolare, alcune operazioni di trattamento dei dati personali potrebbero essere effettuate anche da soggetti terzi, ai quali l’azienda affida l’attività di gestione/manutenzione del sito. In tale evenienza gli stessi soggetti verranno nominati Responsabili del trattamento. Informazioni relative ai responsabili sono reperibili inviando un’email a <a href=\"mailto:pec@pec.spadhausen.com\">pec@pec.spadhausen.com</a>.</p>"
      },
      {
        "type": "html",
        "html": "<h2>Diritti degli interessati</h2><p>I soggetti cui si riferiscono i dati personali hanno il diritto, in qualunque momento, di ottenere la conferma dell’esistenza o meno dei medesimi dati e di conoscerne il contenuto e l’origine, verificarne l’esattezza o chiederne l’integrazione, l’aggiornamento o la rettificazione. Hanno altresì il diritto di chiedere la cancellazione, la trasformazione in forma anonima o il blocco dei dati trattati in violazione di legge, nonché di opporsi, per motivi legittimi, al loro trattamento.</p><p>Ai sensi dell’Art. 13 GDPR UE 679/2016, gli interessati possono in qualunque momento esercitare il diritto di:</p><ul><li>avere accesso ai dati personali;</li><li>ottenere la rettifica o la cancellazione degli stessi o la limitazione del trattamento;</li><li>opporsi al trattamento dei dati;</li><li>utilizzare la portabilità dei dati;</li><li>revocare il consenso in qualsiasi momento senza pregiudicare la liceità del trattamento basato sul consenso conferito prima della revoca;</li><li>proporre reclamo ad una autorità di controllo, per l’Italia il Garante Privacy;</li><li>essere informati circa l’esistenza di un processo decisionale automatizzato, compresa la profilazione, e ricevere informazioni significative sulla logica utilizzata.</li></ul><p>Ai sensi dell’Art. 14 GDPR UE, qualora i dati non siano stati ottenuti presso l’interessato, il Titolare fornirà — entro un termine ragionevole e al più tardi entro un mese — l’identità e i dati di contatto del Titolare, le finalità e la base giuridica del trattamento, le categorie di dati e di destinatari, il periodo di conservazione, i legittimi interessi perseguiti e l’esistenza dei diritti sopra elencati.</p><p>Per qualunque informazione in merito al trattamento dei dati gli utenti possono inviare una email a <a href=\"mailto:pec@pec.spadhausen.com\">pec@pec.spadhausen.com</a>.</p>"
      },
      {
        "type": "callout",
        "html": "<p>La presente Informativa Privacy è soggetta ad aggiornamenti.</p>",
        "icon": "info"
      }
    ]
  },
  "cartaServizi": {
    "header": {
      "eyebrowIcon": "scale",
      "eyebrow": "Documento · Qualità del servizio",
      "title": "Carta dei",
      "titleAccent": "servizi",
      "lead": "Pubblichiamo la nostra Carta dei servizi in ottemperanza agli obblighi di legge in materia di qualità e standard dei servizi di telecomunicazione."
    },
    "intro": "Pubblichiamo la Carta dei servizi in ottemperanza agli obblighi previsti dalla normativa di settore.",
    "meta": [
      {
        "icon": "scale",
        "text": "AGCOM · CSP"
      },
      {
        "icon": "doc",
        "text": "Documento PDF"
      }
    ],
    "regTitle": "Riferimenti normativi",
    "regulations": [
      {
        "source": "Direttiva del Consiglio dei Ministri 27/01/1994",
        "text": "«Principi sull’erogazione dei servizi pubblici»."
      },
      {
        "source": "Delibera 179/03/CSP",
        "text": "Approvazione della direttiva generale in materia di qualità e carte dei servizi di telecomunicazione, ai sensi dell’art. 1, comma 6, lettera b, numero 2 della legge 31 luglio 1997, n. 249."
      },
      {
        "source": "Delibera 131/06/CSP",
        "text": "Approvazione della direttiva in materia di qualità e carte dei servizi di accesso a internet da postazione fissa, ai sensi dell’art. 1, comma 6, lettera b, numero 2 della legge 31 luglio 1997, n. 249."
      },
      {
        "source": "Delibera 248/08/CSP",
        "text": "Disposizioni integrative in materia di qualità dei servizi di comunicazione elettronica."
      }
    ],
    "download": {
      "icon": "doc",
      "title": "Scarica la Carta dei servizi",
      "text": "Il documento completo con standard di qualità, tempi di attivazione, gestione dei reclami e indennizzi previsti. Aggiornato e consultabile in qualsiasi momento.",
      "ctaLabel": "Scarica il documento PDF",
      "ctaHref": "/media/spadhausensrl_cartacartadeiservizi.pdf",
      "metaLabel": "PDF · Spadhausen S.r.l."
    },
    "footerCallout": "<p>Per chiarimenti sugli standard di servizio o per inoltrare un reclamo, scrivici a <a href=\"mailto:info@spadhausen.com\">info@spadhausen.com</a> o chiama lo <strong>0544 2330899</strong>: ti risponde una persona, non un bot.</p>"
  },
  "trasparenza": {
    "header": {
      "eyebrowIcon": "euro",
      "eyebrow": "Documenti · AGCOM",
      "title": "Trasparenza",
      "titleAccent": "tariffaria",
      "lead": "Le schede di trasparenza delle offerte di telefonia e internet in vigore per la clientela privata, come previsto dalla Delibera 252/16/CONS AGCOM. Tutto chiaro, prima di firmare."
    },
    "meta": [
      {
        "icon": "scale",
        "text": "Delibera 252/16/CONS"
      },
      {
        "icon": "doc",
        "text": "Schede in formato PDF"
      },
      {
        "icon": "info",
        "text": "Clientela privata"
      }
    ],
    "groups": [
      {
        "icon": "house",
        "title": "Offerte internet casa",
        "items": [
          {
            "name": "FWA Base",
            "file": "fwa_base.pdf"
          },
          {
            "name": "FTTH Base",
            "file": "ftth_base.pdf"
          },
          {
            "name": "FTTC Base",
            "file": "fttc_base.pdf"
          }
        ]
      },
      {
        "icon": "sim",
        "title": "Offerte mobile casa",
        "items": [
          {
            "name": "Mobile Base",
            "file": "mobile_base.pdf"
          },
          {
            "name": "Mobile Standard",
            "file": "mobile_standard.pdf"
          },
          {
            "name": "Mobile Top",
            "file": "mobile_top.pdf"
          }
        ]
      },
      {
        "icon": "phone",
        "title": "Offerte VoIP casa",
        "items": [
          {
            "name": "VoIP Base",
            "file": "voip_base.pdf"
          },
          {
            "name": "VoIP Tutto Incluso",
            "file": "voip_tutto_incluso.pdf"
          }
        ]
      }
    ],
    "archiveTitle": "Offerte casa scadute",
    "archiveSubtitle": "non più sottoscrivibili, consultabili per i clienti esistenti",
    "archive": [
      {
        "name": "FWA Economy",
        "file": "fwa_economy.pdf"
      },
      {
        "name": "FWA Standard",
        "file": "fwa_standard.pdf"
      },
      {
        "name": "FWA Top",
        "file": "fwa_top.pdf"
      },
      {
        "name": "FWA OF Standard",
        "file": "fwa_of_standard.pdf"
      },
      {
        "name": "FWA OF Top",
        "file": "fwa_of_top.pdf"
      },
      {
        "name": "FTTC Standard",
        "file": "fttc_standard.pdf"
      },
      {
        "name": "FTTC Top",
        "file": "fttc_top.pdf"
      },
      {
        "name": "FTTH Standard",
        "file": "ftth_standard.pdf"
      },
      {
        "name": "FTTH Top",
        "file": "ftth_top.pdf"
      },
      {
        "name": "FTTH OF Standard",
        "file": "ftth_of_standard.pdf"
      },
      {
        "name": "FTTH OF Top",
        "file": "ftth_of_top.pdf"
      },
      {
        "name": "Mobile Base 2025",
        "file": "mobile_base_2025.pdf"
      },
      {
        "name": "Mobile Standard 2025",
        "file": "mobile_standard_2025.pdf"
      },
      {
        "name": "Mobile Top 2025",
        "file": "mobile_top_2025.pdf"
      }
    ],
    "footerCallout": "<p>Non trovi la scheda che cerchi? Le condizioni economiche di ogni offerta sono sempre disponibili in fase di attivazione e il <strong>prezzo concordato resta per sempre</strong>. Scrivici a <a href=\"mailto:info@spadhausen.com\">info@spadhausen.com</a> e ti mandiamo il documento.</p>"
  },
  "conciliaweb": {
    "header": {
      "eyebrowIcon": "scale",
      "eyebrow": "Risoluzione delle controversie · AGCOM",
      "title": "Conciliazione su",
      "titleAccent": "ConciliaWeb",
      "lead": "ConciliaWeb è la piattaforma dell’AGCOM per risolvere gratuitamente e online le controversie tra utenti e operatori di telefonia e internet, senza dover ricorrere al giudice. Ecco a cosa serve e come usarla."
    },
    "intro": "Crediamo che ogni problema vada risolto con una telefonata. Ma se non bastasse, hai sempre uno strumento pubblico, gratuito e indipendente per far valere i tuoi diritti.",
    "meta": [
      {
        "icon": "scale",
        "text": "AGCOM · Co.Re.Com"
      },
      {
        "icon": "euro",
        "text": "Procedura gratuita"
      },
      {
        "icon": "lock",
        "text": "Accesso SPID / CIE"
      }
    ],
    "coseHtml": "<p><strong>ConciliaWeb</strong> è la piattaforma telematica gestita dall’<strong>AGCOM</strong> (Autorità per le Garanzie nelle Comunicazioni) che permette di gestire interamente online le controversie tra gli utenti e gli operatori di comunicazioni elettroniche: telefonia fissa e mobile, accesso a internet e pay-TV.</p><p>È lo strumento con cui puoi tentare di risolvere un disservizio — un guasto non riparato, una fattura contestata, una sospensione del servizio — in modo <strong>rapido, gratuito e senza avvocati</strong>, prima ed eventualmente al posto di un’azione davanti al giudice ordinario.</p>",
    "reclamoHtml": "<p>ConciliaWeb è il <em>secondo</em> passo. Prima devi aver presentato un <strong>reclamo formale</strong> all’operatore e avergli dato il tempo di rispondere. Solo se il problema resta irrisolto puoi aprire un’istanza di conciliazione.</p>",
    "flow": [
      {
        "label": "Passo 1",
        "title": "Reclamo all’operatore",
        "text": "Contatti Spadhausen e segnali il problema: telefono, e-mail o modulo. Ti rispondiamo noi, nella lingua che preferisci."
      },
      {
        "label": "Passo 2 · solo se serve",
        "title": "Istanza su ConciliaWeb",
        "text": "Se la risposta non ti soddisfa o non arriva, apri la conciliazione sulla piattaforma AGCOM."
      }
    ],
    "reclamoCallout": "<p>Il nostro consiglio: <strong>chiamaci prima</strong>. Quasi ogni problema si risolve con una telefonata allo <strong>0544 2330899</strong> o una mail a <a href=\"mailto:info@spadhausen.com\">info@spadhausen.com</a> — senza moduli né attese.</p>",
    "procedureHtml": "<p>Dalla piattaforma puoi attivare tre tipi di procedura, a seconda di cosa ti serve:</p>",
    "procedures": [
      {
        "icon": "scale",
        "tag": "Tentativo obbligatorio",
        "title": "Conciliazione",
        "text": "La procedura principale: un incontro in cui tu e l’operatore, con l’aiuto di un conciliatore del Co.Re.Com, cercate un accordo. È gratuita e obbligatoria prima di rivolgersi al giudice.",
        "meta": "Esito: verbale di accordo",
        "accent": false
      },
      {
        "icon": "bolt",
        "tag": "Provvedimento d’urgenza · GU5",
        "title": "Misure temporanee",
        "text": "Se il servizio è sospeso o interrotto, puoi chiedere un provvedimento temporaneo urgente — ad esempio la riattivazione della linea — in attesa che la controversia si risolva.",
        "meta": "Esito: ripristino rapido",
        "accent": true
      },
      {
        "icon": "shield",
        "tag": "Decisione AGCOM",
        "title": "Definizione",
        "text": "Se la conciliazione non porta a un accordo, puoi chiedere all’Autorità di decidere la controversia con un provvedimento vincolante, anche con eventuali indennizzi.",
        "meta": "Esito: decisione vincolante",
        "accent": false
      }
    ],
    "comeHtml": "<p>Presentare una domanda di conciliazione richiede pochi passaggi, tutti online:</p>",
    "steps": [
      {
        "title": "Accedi alla piattaforma",
        "text": "Vai su <a href=\"https://www.conciliaweb.agcom.it\" target=\"_blank\" rel=\"noopener noreferrer\">conciliaweb.agcom.it</a> e registrati, oppure entra direttamente con <strong>SPID</strong> o <strong>CIE</strong> (Carta d’Identità Elettronica). L’accesso è gratuito."
      },
      {
        "title": "Crea una nuova istanza",
        "text": "Seleziona <strong>“Conciliazione”</strong> (o la procedura che ti serve), poi indica come controparte l’operatore — <strong>Spadhausen S.r.l.</strong> — e i recapiti dell’utenza interessata."
      },
      {
        "title": "Descrivi la controversia",
        "text": "Spiega il problema con parole tue, indica cosa chiedi e <strong>allega il reclamo</strong> già inviato all’operatore insieme a fatture, contratto e ogni documento utile."
      },
      {
        "title": "Invia e attendi la convocazione",
        "text": "Una volta inviata l’istanza, il <strong>Co.Re.Com competente</strong> fissa l’udienza — di norma in videoconferenza — e ti comunica data e ora tramite la piattaforma."
      },
      {
        "title": "Partecipa all’udienza",
        "text": "Nel giorno fissato ti colleghi (di persona o tramite un delegato) e, con l’aiuto del conciliatore, provi a raggiungere un accordo con l’operatore."
      },
      {
        "title": "Ottieni l’esito",
        "text": "In caso di accordo viene redatto un <strong>verbale di conciliazione</strong> con valore di titolo esecutivo. Se l’accordo non si raggiunge, puoi chiedere la <strong>definizione</strong> all’Autorità."
      }
    ],
    "serveHtml": "<p>Prepara questi elementi prima di aprire l’istanza, così sarà tutto più veloce:</p>",
    "need": [
      {
        "icon": "lock",
        "title": "Identità digitale",
        "text": "SPID o CIE per accedere e firmare l’istanza online in modo sicuro."
      },
      {
        "icon": "doc",
        "title": "Copia del reclamo",
        "text": "Il reclamo già inviato all’operatore e l’eventuale risposta ricevuta."
      },
      {
        "icon": "briefcase",
        "title": "Dati del contratto",
        "text": "Numero di utenza/linea, codice cliente e i riferimenti del servizio."
      },
      {
        "icon": "euro",
        "title": "Documentazione",
        "text": "Fatture, screenshot, email: tutto ciò che documenta il disservizio."
      }
    ],
    "facts": [
      {
        "icon": "euro",
        "big": "Gratis",
        "title": "Costo",
        "text": "La procedura di conciliazione tramite ConciliaWeb è completamente gratuita per l’utente."
      },
      {
        "icon": "clock",
        "big": "~30 giorni",
        "title": "Tempi",
        "text": "L’udienza viene di norma fissata entro circa 30 giorni dalla presentazione dell’istanza."
      },
      {
        "icon": "scale",
        "big": "Esecutivo",
        "title": "Esito",
        "text": "Il verbale di accordo ha valore di titolo esecutivo: è vincolante per entrambe le parti."
      }
    ],
    "download": {
      "icon": "scale",
      "title": "Vai su ConciliaWeb",
      "text": "Accedi alla piattaforma ufficiale dell’AGCOM con SPID o CIE per presentare la tua istanza di conciliazione. È gratuita e si gestisce tutto da casa.",
      "ctaLabel": "Apri conciliaweb.agcom.it",
      "ctaHref": "https://www.conciliaweb.agcom.it",
      "metaLabel": "AGCOM · accesso SPID / CIE"
    },
    "footerCallout": "<p>Hai un dubbio prima di procedere? Parla con noi: chiama lo <strong>0544 2330899</strong> o scrivi a <a href=\"mailto:info@spadhausen.com\">info@spadhausen.com</a>. Ti aiutiamo a capire qual è la strada giusta — anche quando è ConciliaWeb.</p>",
    "faq": [
      {
        "question": "Cos’è esattamente ConciliaWeb?",
        "answer": "<p>È la <strong>piattaforma online dell’AGCOM</strong> (Autorità per le Garanzie nelle Comunicazioni) per risolvere gratuitamente le controversie tra utenti e operatori di comunicazioni elettroniche — telefonia, internet e pay-TV — <strong>senza ricorrere al giudice</strong>.</p>"
      },
      {
        "question": "Devo per forza fare prima un reclamo a Spadhausen?",
        "answer": "<p>Sì. Prima di aprire un’istanza su ConciliaWeb devi aver inviato un <strong>reclamo formale all’operatore</strong> e avergli dato il tempo di rispondere. Il nostro consiglio resta sempre lo stesso: <strong>contattaci prima</strong> — quasi tutto si risolve con una telefonata o una mail, con una persona reale che parla la tua lingua.</p>"
      },
      {
        "question": "Quanto costa?",
        "answer": "<p>Nulla. Il <strong>tentativo di conciliazione</strong> tramite ConciliaWeb è <strong>gratuito</strong>. Non servono avvocati: puoi presentare l’istanza da solo o farti assistere da un’associazione di consumatori.</p>"
      },
      {
        "question": "Come accedo alla piattaforma?",
        "answer": "<p>Vai su <a href=\"https://www.conciliaweb.agcom.it\" target=\"_blank\" rel=\"noopener noreferrer\">conciliaweb.agcom.it</a> e accedi con <strong>SPID</strong> o <strong>CIE</strong>. Da lì crei una nuova istanza, indichi l’operatore e alleghi la documentazione.</p>"
      },
      {
        "question": "È obbligatorio prima di andare dal giudice?",
        "answer": "<p>Sì. Per le controversie tra utenti e operatori il <strong>tentativo di conciliazione è una condizione di procedibilità</strong>: va esperito prima di poter agire in giudizio. Se la conciliazione fallisce, puoi chiedere all’AGCOM la <strong>definizione</strong> della controversia.</p>"
      },
      {
        "question": "Cosa succede dopo l’udienza?",
        "answer": "<p>Se si trova un accordo, viene redatto un <strong>verbale di conciliazione</strong> con valore di titolo esecutivo. Se l’accordo non si raggiunge, ricevi un verbale di mancato accordo e puoi proseguire con la <strong>definizione</strong> davanti all’Autorità.</p>"
      }
    ]
  }
}
